import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { ApiError } from '~/lib/api';
import type { IApiGetUserBadgesResponseBody } from '../UserBadgesApi.types';
import { IQueryKeyFactory } from '~/helpers/types';
import { useApi } from '~/lib/api/useApi';

export type IUseUserBadgesQueryValues = {
  appId: string;
};

export const userBadgesQueryKeyFactory: IQueryKeyFactory<
  IUseUserBadgesQueryValues
> = (values) => values && (['userBadges', values.appId] as const);

export const useUserBadgesQuery = (
  values?: IUseUserBadgesQueryValues,
  options?: UseQueryOptions<IApiGetUserBadgesResponseBody, ApiError>,
): UseQueryResult<IApiGetUserBadgesResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: userBadgesQueryKeyFactory(values),
    queryFn: values ? () => api.userBadges.getAll(values.appId) : undefined,
    ...options,
  });
};
